module.exports = __webpack_public_path__ + "static/img/anxun21new3.64f86e36.png";